import fs from 'app/native/node/fs';
import path from 'app/native/node/path';
import unusedFilename from 'app/native/modules/unused-filename';

export default async function saveFileWithoutOverwrite(directory, filename, data) {
  const xrayHistorySavePath = await unusedFilename()(path().join(directory, filename));
  await fs().promises.writeFile(xrayHistorySavePath, data, { encoding: 'utf8' });
  return xrayHistorySavePath;
}
